import type { IWixAPI } from '@wix/yoshi-flow-editor';

export const isEditorOrPreview = (wixCodeApi: IWixAPI) => {
  const viewMode = wixCodeApi.window.viewMode;
  return viewMode === 'Editor' || viewMode === 'Preview';
};

export const getFieldsets = () =>
  'fieldsets=categories,owner,likes,content,subscriptions,tags,seo,translations,urls';
